var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sidebar{padding:40px;display:flex;flex-direction:column;justify-content:space-between;align-items:space-between;position:fixed;width:100%;z-index:3;height:100%}.navbar-brand{font-size:1.4rem;padding-bottom:1rem}.nav-link,.nav-link:hover{font-size:1.2rem;color:#000;padding:0}.talk a{display:flex;flex-direction:row;align-items:center}.talk div{background-image:url(" + escape(require("./assets/talk.png")) + ");background-repeat:no-repeat;background-size:contain;background-position:50%;height:30px;min-width:30px;margin-right:5px}.invert{filter:invert(100%)}@media screen and (max-width:900px){#sidebar{padding:24px}.invert{filter:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bca7314","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/side-nav.vue
// module id = 323
// module chunks = 0